import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createBlock(_component_BaseDialog, {
    dialog: $props.dialog,
    title: $options.titleCapture,
    onClose: $options.closeModal,
    onSumbitData: $options.deleteContact
  }, {
    dataFields: _withCtx(() => [
      _createElementVNode("p", {
        class: "text-subtitle-1 text-center",
        innerHTML: $options.subtitleCapture
      }, null, 8, _hoisted_1)
    ]),
    mainAction: _withCtx(() => [
      _createVNode(_component_v_btn, {
        variant: "outlined",
        color: "blue",
        type: "submit"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            small: "",
            class: "mr-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-delete-outline")
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString($options.buttonCapture), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["dialog", "title", "onClose", "onSumbitData"]))
}